<template>
  <v-app>
    <AppBar
      @showAnnouncements="showAnnouncementDrawer = !showAnnouncementDrawer"
    />
    <SideNavigation />
    <v-main style="position: relative" class="background_color overflow-y-auto">
      <v-container
        fluid
        class="pa-0"
        style="height: 100% !important; position: absolute"
      >
        <v-skeleton-loader
          v-if="!hasProfileInfo"
          class="pa-4"
          type="table-theader, article, actions, table-heading, list-item-three-line, list-item-three-line, image, list-item-three-line"
        ></v-skeleton-loader>
        <router-view v-else />
      </v-container>
    </v-main>
    <AnnouncementDetails
      v-if="showAnnouncementDrawer"
      v-model="showAnnouncementDrawer"
    />
    <BasicSetupComponent
      v-model="showBasicSetup"
      :startingStep="startingStep"
    />
  </v-app>
</template>

<script>
import AppBar from "@/components/BaseComponents/AppBar.vue";
import SideNavigation from "@/components/BaseComponents/SideNavigation.vue";
import { mapActions, mapState } from "vuex";
import { checkifLoggedIn, getUserDetailsLocalStorage } from "@/utils/functions";
import AnnouncementDetails from "@/components/ModuleBasedComponents/Announcement/AnnouncementDetails.vue";
import { bus } from "@/main";
import BasicSetupComponent from "@/components/BaseComponents/BasicSetupComponent.vue";

export default {
  name: "adminLayout",
  components: {
    AppBar,
    SideNavigation,
    AnnouncementDetails,
    BasicSetupComponent,
  },
  data() {
    return {
      drawer: false,
      appLoading: false,
      showBasicSetup: false,

      showAnnouncementDrawer: false,
      startingStep: 1,
    };
  },
  computed: {
    ...mapState("userProfile", {
      userTheme: (state) => state.userTheme,
      updateTheme: (state) => state.updateTheme,
      hasProfileInfo: (state) => state.hasProfileInfo,
    }),
  },
  methods: {
    ...mapActions("userProfile", ["getUserProfileInfo"]),
    redirectIfLoggedIn() {
      let isLoggedIn = checkifLoggedIn();
      if (isLoggedIn) {
        let user = getUserDetailsLocalStorage();
        if (["account_manager", "system_admin"].indexOf(user.role) > -1) {
          if (this.$route.fullPath.indexOf("/admin") == -1) {
            this.$router.replace({ name: "admin" });
          }
        } else if (["support_user"].indexOf(user.role) > -1) {
          if (this.$route.fullPath.indexOf("/support-user") == -1) {
            this.$router.replace({ name: "support_user" });
          }
        } else {
          if (this.$route.fullPath.indexOf("/client") == -1) {
            this.$router.replace({ name: "client" });
          }
        }
      } else {
        if (this.$route.fullPath.indexOf("/login") == -1) {
          this.$router.replace({ name: "login" });
        }
      }
    },
    async checkForBasicSetup() {
      await this.getUserProfileInfo()
        .then((res) => {
          if (
            res &&
            res.company_details &&
            res.company_details.no_of_step_completed &&
            res.company_details.no_of_step_completed <= 4
          ) {
            this.startingStep = res.company_details.no_of_step_completed;
            this.showBasicSetup = true;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  async created() {
    await this.checkForBasicSetup();
    this.$wbSocket.connection();
    this.$wbSocket.notificationConnection();
    bus.$on("checkForBasicSetup", this.checkForBasicSetup);
  },

  beforeDestroy() {
    this.redirectIfLoggedIn();
    bus.$off("checkForBasicSetup", this.openSetupComponent);
  },
};
</script>
